var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.639 1.207.573 1.352c.25.59.111 1.282-.343 1.712l-1.07 1.016a.506.506 0 0 0-.157.445c.103.627.332 1.246.687 1.856A5.843 5.843 0 0 0 5.622 9.14a.51.51 0 0 0 .489.087l1.249-.417c.575-.191 1.2.03 1.553.547l.822 1.207c.41.602.336 1.433-.172 1.944l-.546.547a2.014 2.014 0 0 1-2.034.519c-1.693-.528-3.249-2.096-4.669-4.703C.892 6.262.39 4.046.809 2.227.985 1.461 1.529.852 2.24.624L2.96.395c.673-.214 1.392.133 1.68.812Z",
    fill: "#323232"
  })));
};

export default SvgPhone;